import React, { useEffect, useState } from "react";
import { Modal, Table, Button, Spinner, Alert } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

export default function AvizePickerModal({ show, onHide, contactId, onPick }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    if (show && contactId) {
      setLoading(true);
      setError("");
      authFetch(`/intrare/avize/disponibile?contact_id=${contactId}`)
        .then((res) => {
          setDocs(res.items || []);
        })
        .catch((e) => {
          setError(e.message || "Eroare la încărcarea avizelor");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [show, contactId]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    try {
      const d = new Date(dateStr);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    } catch {
      return dateStr;
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Preluare din aviz</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        )}
        {error && <Alert variant="danger">{error}</Alert>}
        {!loading && !error && docs.length === 0 && (
          <Alert variant="info">Nu există avize finalizate cu cantități rămase de facturat pentru acest partener.</Alert>
        )}
        {!loading && docs.length > 0 && (
          <Table striped bordered hover size="sm">
            <thead>
              <tr>
                <th>Număr Aviz</th>
                <th>Dată</th>
                <th className="text-end">Valoare</th>
                <th className="text-center">Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((d) => (
                <tr key={d.id}>
                  <td>{d.bxdoc_no || `Aviz #${d.id}`}</td>
                  <td>{formatDate(d.bxdoc_date)}</td>
                  <td className="text-end">{Number(d.bxgvalue || 0).toFixed(2)}</td>
                  <td className="text-center">
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => {
                        onPick(d.id);
                        onHide();
                      }}
                    >
                      Preluare
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
